let productName = "";
let packageVersion = "";
let publicSite = false;

export function setProductName(name: string): void {
    productName = name;
}

export function getProductName(): string {
    return productName;
}

export function getPackageVersion(): string {
    return packageVersion;
}

export function setPackageVersion(version: string) {
    packageVersion = version;
}

export function setIsPublicSite(isPublic: boolean): void {
    publicSite = isPublic;
}

export function isPublicSite(): boolean {
    return publicSite;
}
